import {formatDecimalNumber} from '@/utils/serverNumberLimit';

//小数点分割
export function xiaoshudianfenge(inputValue, tempUserSetting) {
    return toThousandsNoZero(inputValue, tempUserSetting);
}

//小数点分割
export function toThousandsNoZero(num, tempUserSetting) {
    tempUserSetting = tempUserSetting || {};
    const configuredDecimalPlaces = Number(tempUserSetting.currencyDecimalPlaces);
    const decimalPlaces = Number.isInteger(configuredDecimalPlaces)
        && configuredDecimalPlaces >= 0 && configuredDecimalPlaces <= 5 ? configuredDecimalPlaces : 2;
    const configuredPlacement = Number(tempUserSetting.currencyPlacementAtBefore);
    const currencyPlacementAtBefore = configuredPlacement === 0 || configuredPlacement === 1
        ? configuredPlacement : 1;
    const fixedValue = formatDecimalNumber(num, decimalPlaces);
    const parts = fixedValue.split('.');
    const sign = parts[0].startsWith('-') ? '-' : '';
    const unsignedInteger = sign === '' ? parts[0] : parts[0].substring(1);
    const thousandSymbol = tempUserSetting.currencyThousandSymbol == null
        ? ',' : String(tempUserSetting.currencyThousandSymbol);
    const decimalSymbol = tempUserSetting.currencyDeciamlSymbol == null
        ? '.' : String(tempUserSetting.currencyDeciamlSymbol);
    const groupedInteger = unsignedInteger.replace(/\B(?=(\d{3})+(?!\d))/g, thousandSymbol);
    const resultMoney = sign + groupedInteger
        + (decimalPlaces === 0 ? '' : decimalSymbol + parts[1]);
    return formatMoney(resultMoney, Object.assign({}, tempUserSetting, {currencyPlacementAtBefore}));
}

export function formatMoney(resultMoney, tempUserSetting) {
    const currency = tempUserSetting.currency == null ? '' : String(tempUserSetting.currency);
    if (tempUserSetting.currencyPlacementAtBefore === 1) {
        return currency + resultMoney;
    }
    return resultMoney + currency;
}
